import {
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router";
import { PATHS } from "../routing/paths";
import { CognitoUserPool } from "amazon-cognito-identity-js";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";

const poolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
  ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID!,
};
const userPool = new CognitoUserPool(poolData);

export default function Header() {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    const currentUser = userPool.getCurrentUser();
    if (currentUser) {
      currentUser.signOut();
    }
    navigate(PATHS.signIn, { replace: true });
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          onClick={() => navigate(PATHS.dashboard)}
          sx={{ cursor: "pointer" }}
        >
          Terminchat Administration App
        </Typography>

        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate(PATHS.dashboard);
            }}
          >
            Dashboard
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate(PATHS.openingHours);
            }}
          >
            Öffnungszeitenverwaltung
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate(PATHS.staff);
            }}
          >
            Personalverwaltung
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              handleLogout();
            }}
          >
            Abmelden
          </MenuItem>
        </Menu>

        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ marginLeft: "auto" }}
          onClick={handleMenuOpen}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
